export enum SampleStatusYearPreset {
    Last2Years = 102,
    Last3Years = 103,
    Last5Years = 104,
}
